import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_OutPatientTreatmentRequest = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_OutPatientTreatmentRequest' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><center><h3>Global Assessment of Functioning (©Axix V, DSMIV-TR) - Adult Mental Health </h3></center>
                </p> 

                <p className='w-750'><b>Instructions:</b> Estimated GAF (step 3) should correlate GAF below.
                    Consider the lowest possible score! Code global functioning from superior (99) to grossly impaired (1) in line with rating definitions below. Consider impairments in functioning due to physical limitations as well as those due to mental impairments. Do not consider environmental limitations (e.g., "no jobs available").</p>

                <p className='w-750'><b>1 - 10 Persistent danger of severely hurting self or others:</b>
                    <br />
                    Serious suicidal act w/ clear expectation of death, frequent severe violence or self-mutilation; extreme manic excitement, agitation, impulsivity; persistent inability to maintain minimal personal hygiene; urgent/emergent admissions to crisis unit/hospital; acute, severely impaired (medical complications imminent).</p>

                <p className='w-750'><b>11 - 20 Some danger of hurting self/others:</b>
                    <br />
                    Severe violence, self-mutilating, suicidal behaviors w/o clear expectation of death; severe manic excitement, agitation, impulsivity; occasionally fails to maintain minimal personal hygiene (diarrhea/smears feces); urgent/emergent admissions to crisis unit/hospital; physical danger due to medical problems w/ mental illness.</p>

                <p className='w-750'><b>21 - 30 Inability to function in almost all areas:</b>
                    <br />
                    Suicidal preoccupations, delusions, hallucinations, or serious impairments with work, school, family responsibilities, home care, friends & family relationships and including serious impairments in judgment, thinking, mood, panic attacks, anxiety.</p>

                <p className='w-750'><b>31-40 Major impairment in several (2+) areas of functioning:</b>
                    <br />
                    Substantial impairments with work, school, housework, friends or family relationships, problem solving, making decisions, paranoia, constant depression (hopeless), some hallucinations, delusions.</p>

                <p className='w-750'><b>41-50 Serious symptoms OR seriously impaired functioning:</b>
                    <br />
                    Serious impairment or problems in either work, school, housework, relationships, problem solving, communication, coping.</p>

                <p className='w-750'><b>For med. maintenance, counseling/support, consider 51 - 70</b> </p>

                <p className='w-750'><b>
                    51 - 60 Moderate impairments in functioning or moderate symptoms:</b>
                    <br />
                    Moderate difficulty in social, work or school functioning (e.g., conflicts or few friends); frequent moderately depressed mood & insomnia, ruminating, obsessing; occasional anxiety attack, flat affect, circumstantial speech.</p>

                <p className='w-750'><b>61 - 70 Some persistent mild symptoms of MI/SA/MR.</b>
                    <br />
                    <b>Note: OPTIMALLY FUNCTIONAL - INDEPENDENT LIVING: WORK AND HOUSING!</b>
                    <br />
                    Mild symptoms are present that are NOT just expectable reactions to psychosocial stresses (e.g., mild or lessened depression, insomnia); some difficulties in social or occupational functioning such as repeated falling behind in work, productivity, BUT has meaningful interpersonal relationships.
                </p>

                <p className='w-750'><b>GAF codes 71-90 reserved for maintenance/short term</b> </p>

                <p className='w-750'><b>71 - 80 Some transient mild symptom impairments:</b>
                    <br />
                    Mild symptoms are present that ARE transient and expectable reactions to prychosocial stresses (e g., difficulty concentrating after family argument); good functioning with only mild, expected problems in family, social, work functioning as a result of stress.
                </p>

                <p className='w-750'><b>81 - 90 Absent or minimal impairments:</b>
                    <br />
                    Optimal functioning in all areas, SATISFIED WITH LIFE; interested and involved in a wide range of activities; socially effective; no more than everyday problems, concerns (eg., mild anxiety before a job interview, marriage).
                </p>

                <p className='w-750'><b>91 - 100 Optimal functioning in all areas, no symptoms.</b>
                </p>

                <table>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Evaluation Date 1 Rater Signature (include credentials)</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Time(AM/PM)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtEvaluationDate_1' name='txtEvaluationDate_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtEvaluationTime_1' name='txtEvaluationTime_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Review Date 2 Rater Signature (include credentials)</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Time(AM/PM)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtReviewDate_1' name='txtReviewDate_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtReviewTime_2' name='txtReviewTime_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Review Date 3 Rater Signature (include credentials)</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Time(AM/PM)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtReviewDate_4' name='txtReviewDate_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtReviewTime_3' name='txtReviewTime_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Review Date 4 Rater Signature (include credentials)</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Time(AM/PM)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtReviewDate_7' name='txtReviewDate_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtReviewTime_4' name='txtReviewTime_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Review Date 5 Rater Signature (include credentials)</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Date</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Time(AM/PM)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtReviewDate_10' name='txtReviewDate_10' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDate_5' name='txtDate_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtReviewTime_5' name='txtReviewTime_5' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







